//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import { PATTERNS_VALIDATION, ALL_TABLES_OPTION } from '@/js/constants';
import MoreFilterSearch from '@/components/MoreFilterSearch.vue';
import DatastudioReportService from '@/apps/data-platform/services/visualization/datastudio_report_service';
export default {
  name: 'MainSearch',
  components: {
    MoreFilterSearch: MoreFilterSearch
  },
  data: function data() {
    return {
      id: '',
      url: '',
      isLoadingIframe: true,
      inframeHeight: 100
    };
  },
  computed: {},
  created: function created() {
    this.id = this.$router.currentRoute.params.id;
  },
  mounted: function mounted() {
    this.onShowReport(this.id);
    var heightSearch = document.getElementById("SEARCH").clientHeight;
    console.log(window.innerHeight, "-", heightSearch);
    this.inframeHeight = window.innerHeight - (heightSearch + 50);
    console.log(this.inframeHeight);
  },
  methods: {
    onShowReport: function onShowReport(id) {
      var _this = this;
      var param = {
        report_id: id
      };
      DatastudioReportService.getReportById(param).then(function (res) {
        console.log(res);
        if (res.data) {
          var data = {
            "domain": res.data.domain_org
          };
          DatastudioReportService.generateToken(data).then(function (response) {
            console.log(response);
            var paramsAsString = JSON.stringify(response.data.params);
            var paramsEncoded = encodeURIComponent(paramsAsString);
            _this.url = "".concat(res.data.access_link, "?params=").concat(paramsEncoded);
          });
        }
      });
    },
    loadIframe: function loadIframe() {
      console.log("loaded");
      this.isLoadingIframe = false;
    },
    onCloseReport: function onCloseReport() {
      this.$router.push({
        name: 'MyTables',
        params: {
          tab: 8
        }
      });
    }
  }
};